module.exports = "/_next/static/images/special-a62bf57c7b632a2c4afeafa835f2e5dd.jpg";